'use strict';

var cache = {};
var preferences = require('../../../../config/preferences');

module.exports = {
    initQtySelectorCache: function () {
        cache.$body = $('body');
    },
    initQtySelectorEvent: function () {
        this.initQtySelectorCache();

        cache.$body.on('change', '.js-qty', function (e) {
            var $this = $(this);
            var qty = $this.val();
            var pid = $this.data('pid');
            var preSelectedQty = $this.data('pre-select-qty');
            var maxOrderQty = preferences.maxOrderQty;
            var $errorMsg = $(`.cart-quantity-error-msg.${pid}`);

            if (qty > maxOrderQty) {
                $this.val(maxOrderQty);
                $errorMsg.show();
                return;
            }

            if (qty == '0' || qty == '') {
                e.stopImmediatePropagation();
                $this.val(Math.abs(preSelectedQty));
                return false;
            }

            $this.attr('aria-label', `quantity: ${qty}`);
        });

        cache.$body.on('click', '.js-form-qty', function (e) {
            var $target = $(e.target.tagName === 'I' ? e.target.parentElement : e.target);
            var $this = $(this);
            var pid = $this.find('.js-qty').data('pid');
            var $qtyInput = $this.find('.js-qty');
            var $addQtyBtn = $this.find('.js-add-qty');
            var $remQtyBtn = $this.find('.js-remove-qty');
            var selectedQty = parseInt($qtyInput.val(), 10);
            var minQty = parseInt($qtyInput.data('min-qty'), 10);
            var maxOrderQty = preferences.maxOrderQty;
            var $errorMsg = $(`.cart-quantity-error-msg.${pid}`);
            $errorMsg.hide();

            if ($target.hasClass('js-add-qty')) {
                selectedQty++;
                $target.attr('disabled', false);
                $remQtyBtn.attr('disabled', false);
                if (selectedQty > maxOrderQty) {
                    $errorMsg.show();
                    e.stopImmediatePropagation();
                    return;
                }
                $qtyInput.val(selectedQty);
                $qtyInput.trigger('change');
            }

            if ($target.hasClass('js-remove-qty')) {
                selectedQty--;
                $target.attr('disabled', false);
                $addQtyBtn.attr('disabled', false);

                if (selectedQty <= minQty) {
                    selectedQty = minQty;
                    $target.attr('disabled', true);
                }

                $qtyInput.val(selectedQty);
                $qtyInput.trigger('change');
            }
        });
    }
};
